require('formdata-polyfill')
require('regenerator-runtime/runtime')
const {bind} = require('../lib/bind')
const {Post} = require('../lib/ajax')
const {Get} = require('../lib/ajax')
const niceBytes = require('../lib/nice-bytes')
const Process = require('./process')

class Upload {
  constructor(dropzone) {
    this.dropzone = dropzone
    this.element = document.querySelector('.js-upload-form')
    this.uploading = document.querySelector('.js-upload-uploading')
    this.progress = document.querySelector('.js-upload-progress')
    this.filename = document.querySelector('.js-upload-filename')
    this.status = document.querySelector('.js-upload-status')
    this.cancelButton = document.querySelector('.js-upload-cancel')
    this.formData = new FormData(this.element)
    this.request = null
    this.key = null

    bind(this.cancelButton, 'click', this.stop.bind(this))
  }

  setFile(file) {
    this.formData.set('file', file);
  }

  async start() {
    const file = this.formData.get('file')
    if (file.type === 'application/pdf') {
      // Check file size limit
      var file_size_limit = await new Promise((resolve, reject) => {
        new Get('/account/settings.json', {
          success: function(response) {
            resolve(response['file_size_limit'])
          },
          error: function(response) {
            console.log('Error uploading PDF', response)
            reject(response)
          }
        })
      })

      if (file.size > file_size_limit) return this.dropzone
          .showError(`This deck is over the ${niceBytes(file_size_limit)} limit for uploading. Please reduce the file size and try again.`)

      this.showProgress()
      this.filename.innerText = this.formData.get('file').name

      this.request = new Post(this.element.action, {
        success: this.onSuccess.bind(this),
        error: this.onError.bind(this),
        progress: this.onProgress.bind(this),
        data: this.formData,
        type: 'xml',
        successStatus: 201
      })
    } else {
      this.dropzone.showError('Please select a PDF to upload.')
    }
  }

  showDropzone() {
    this.dropzone.showElement()
    this.hideElement()
  }

  showProgress() {
    this.status.innerText = "Uploading…"
    this.dropzone.hideElement()
    this.showElement()
  }

  showElement() {
    document.body.classList.add('is-uploading')
    this.uploading.classList.add('d-flex')
    this.uploading.classList.remove('d-none')
  }

  hideElement() {
    document.body.classList.remove('is-uploading')
    this.uploading.classList.remove('d-flex')
    this.uploading.classList.add('d-none')
  }

  stop(e) {
    e.preventDefault()
    e.stopPropagation()
    this.request.abort()
    this.showDropzone()
  }

  onProgress(e) {
    const percent = Math.floor(100 * e.loaded / e.total)
    this.progress.style.width = `${percent}%`
    this.status.innerText = `Uploaded ${niceBytes(e.loaded)} of ${niceBytes(e.total)} (${percent}%)`
  }

  onSuccess(response) {
    this.cancelButton.classList.add('d-none')
    this.key = response.querySelector('Key').childNodes[0].nodeValue

    new Process(this)
  }

  filenameFromKey() {
    return this.key.split('/').pop()
  }

  onError() {
    // TODO: Make this work
  }
}

module.exports = Upload
